import React from "react";
import { Wrapper } from "./Heading.styled";

export default function Heading({ className, style, text }) {
  return (
    <Wrapper>
      <p className={className} style={style}>
        {text}
      </p>
    </Wrapper>
  );
}
